import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

import { Items } from '../../models/items';
import {UtilsService} from '../../services/utils.service';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.css']
})
export class NavItemComponent implements OnInit {
  @Input() public navItems: Items[];
  @Output() onClicked = new EventEmitter<Items>();

  constructor(
      private utilsService: UtilsService
  ) { }

  ngOnInit() {
  }

  click(item: Items) {
    if (item.type === 'LINK' && item.referenceType !== 'EXTERNAL_LINK') {
      this.utilsService.debugLog(item);
      this.onClicked.emit(item);
    }
  }

  childClicked(item: Items) {
    this.onClicked.emit(item);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/nav-item/nav-item.component.ts